<template>
  <div>
    <CustomAlert
      title=""
      :type="percentComplete == 100 ? 'success' : 'warning'"
    >
      <div class="text-center fw-bold">
        <div
          class="badge fs-6 w-100"
          :class="{
            'bg-success': percentComplete == 100,
            'bg-warning text-dark': percentComplete < 100
          }"
        >
          {{ percentComplete }}% Complete
        </div>
        <br />
        ({{ totalCount - emptyStringCount }}/{{ totalCount }} form fields)
      </div>
    </CustomAlert>
  </div>
</template>

<script>
import CustomAlert from "@/components/ui/CustomAlert";

export default {
  name: "ProgressBar",
  components: {
    CustomAlert
  },
  data() {
    return {
      emptyStringCount: 0,
      totalCount: 0
    };
  },
  props: {
    formData: {
      type: Object
    }
  },
  computed: {
    percentComplete() {
      if (this.totalCount == 0) {
        return 0;
      }

      let calc = (this.totalCount - this.emptyStringCount) / this.totalCount;
      calc *= 100;
      calc = Math.round(calc);

      return calc;
    },
    checkEmptyStrings() {
      try {
        return this.searchForEmptyStrings(this.formData);
      } catch (error) {
        console.log(error);
        return false;
      }
    }
  },
  methods: {
    processEmptyStrings(value) {
      //   lets use a stack to keep track of the nested objects (plain strings, array, or object) that need to be checked for empty strings
      if (!value) {
        return;
      }
      this.modData = JSON.parse(JSON.stringify(value));
      let stack = [this.modData];

      let emptyStringCount = 0;
      let totalCount = 0;

      while (stack.length > 0) {
        const current = stack.pop();
        // lets check if the current item is an empty string

        if (typeof current === "string") {
          totalCount += 1; // keep track of total strings
          if (current === "") {
            emptyStringCount += 1; // keep track of total empty strings
          }
        }

        // if its an array, lets push all the items onto the stack
        if (Array.isArray(current)) {
          current.forEach((item) => stack.push(item));
        } else if (typeof current === "object" && current !== null) {
          // needed to do if/else, because it was pushing to the stack twice.

          // all labs included id
          if (current?.id) {
            delete current.id;
          }

          // some labs included form name
          if (current?.formName) {
            delete current.formName;
          }

          // Lab 5, calculated values
          if (current?.calculatedData) {
            delete current.calculatedData;
          }
          if (current?.calculatedHydraulicGradients) {
            delete current.calculatedHydraulicGradients;
          }

          if (current?.dyeDropExperiment) {
            delete current.dyeDropExperiment;
          }

          // Lab 5, unused values
          if (current?.capturingMathWork) {
            delete current.capturingMathWork;
          }
          Object.values(current).forEach((item) => stack.push(item));
        }
      }

      // assign the local values to the component values
      this.emptyStringCount = emptyStringCount;
      this.totalCount = totalCount;
    }
  },
  watch: {
    formData: {
      handler: function (val) {
        // run every time formdata is updated
        this.processEmptyStrings(val);
      },
      deep: true
    }
  },
  mounted() {
    // run first time when component is mounted
    this.processEmptyStrings(this.formData);
  }
};
</script>
